import { useQuery } from '@tanstack/react-query';
import api from '@/Services/api';
import { API } from '@/Services/apiConfig';
import { FoodUpdate } from '@/types/menu';

export const FOOD_CATALOG_KEY = ['food-catalog'];

export const useFoodCatalog = () => {
    return useQuery({
        queryKey: FOOD_CATALOG_KEY,
        queryFn: async () => {
            const { data } = await api.get(API.FOOD_VARIANTS);
            const updates: FoodUpdate[] = data ?? [];
            const map = new Map<number, FoodUpdate>();
            for (const u of updates) {
                map.set(u.id, u);
            }
            return map;
        },
    });
};
